module.exports = __webpack_public_path__ + "img/virus.37989027.png";